import { Component, Input, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface MetricItem {
  label: string;
  value: number | string;
  isDate?: boolean;
  icon?: string;
}

@Component({
  selector: 'app-metrics-dashboard',
  imports: [CommonModule],
  templateUrl: './metrics-dashboard.component.html'
})
export class MetricsDashboardComponent {
  @Input() metrics: MetricItem[] = [];
  readonly isRefreshing = input<boolean>(false);
}
